module.exports = __webpack_public_path__ + "static/assets/9c0dda925ff4840f5ddfe6c27f1a2755.png";